// Mobile Navigation Menu Controller with jQuery
(function ($) {
  "use strict";

  class MobileNavigation {
    constructor() {
      this.$dialog = $('[role="dialog"]');
      this.$closeBtn = $('[data-tid="close-btn"]');
      this.$overlay = $(".dialog-content-overlay");
      this.$navItems = $(".nav-item");
      this.$actionMenu = $(".action-menu");
      this.$navL2Categories = $(".nav-l2__category");
      this.$mobileMenuFooter = $("#mobile-menu-footer");

      this.init();
    }

    init() {
      // Sync initial state for L1 items
      this.$navItems.each((index, item) => {
        const $item = $(item);
        const $navLink = $item.find(".nav-link").first();
        const $subMenu = $item.find(".nav-l2").first();

        if ($navLink.hasClass("nav-link--open") && $subMenu.length) {
          $subMenu.show();
        }
      });

      // Sync initial state for L2 items
      this.$navL2Categories.each((index, category) => {
        const $category = $(category);
        const $toggleBtn = $category.find(".nav-l2__arrow-toggle");
        const $subMenu = $category.find("div").first();

        if ($toggleBtn.hasClass("arrow-toggle--open") && $subMenu.length) {
          $subMenu.show();
        }
      });

      // Close modal when clicking close button
      this.$closeBtn.on("click", () => this.closeModal());

      // Close modal when clicking overlay
      this.$overlay.on("click", () => this.closeModal());

      // Handle toggle for each nav item (Level 1)
      this.$navItems.each((index, item) => {
        const $item = $(item);
        const $toggleBtn = $item.find(".nav-arrow-toggle");

        if ($toggleBtn.length) {
          $toggleBtn.on("click", (e) => {
            e.stopPropagation();
            this.toggleNavItem($item);
          });
        }
      });

      // Handle toggle for L2 subcategories
      this.$navL2Categories.each((index, category) => {
        const $category = $(category);
        const $toggleBtn = $category.find(".nav-l2__arrow-toggle");

        if ($toggleBtn.length) {
          $toggleBtn.on("click", (e) => {
            e.stopPropagation();
            this.toggleL2Category($category);
          });
        }
      });

      // Handle toggle for action menu (Special offer)
      if (this.$actionMenu.length) {
        const $actionToggle = this.$actionMenu.find(".action-menu__arrow-wrap");
        if ($actionToggle.length) {
          $actionToggle.on("click", () => {
            this.toggleActionMenu();
          });
        }
      }

      // Close modal when pressing ESC
      $(document).on("keydown", (e) => {
        if (e.key === "Escape" && this.isModalOpen()) {
          this.closeModal();
        }
      });

      // Initialize mobile menu footer
      this.initMobileMenuFooter();
    }

    // Initialize mobile menu footer handlers
    initMobileMenuFooter() {
      if (!this.$mobileMenuFooter.length) return;

      const currentPath = window.location.pathname;

      // Set active state on page load
      this.setActiveMenuItem(currentPath);

      // Home button
      this.$mobileMenuFooter.find('a[href="/"]').on("click", (e) => {
        this.setActiveMenuItem("/");
      });

      // Categories button
      this.$mobileMenuFooter
        .find('[data-tid="mobile-menu-footer-categories"]')
        .on("click", (e) => {
          this.setActiveMenuItem("categories");
          if (this.isModalOpen()) {
            this.closeModal();
          } else {
            this.openModal();
          }
        });

      // Search button (assuming it's the second button)
      this.$mobileMenuFooter
        .find("button")
        .eq(1)
        .on("click", (e) => {
          this.setActiveMenuItem("search");
          // Add search logic here if needed
        });

      // Cart button
      this.$mobileMenuFooter.find('a[href*="cart"]').on("click", (e) => {
        this.setActiveMenuItem("cart");
      });
    }

    // Set active state for mobile menu footer items
    setActiveMenuItem(target) {
      if (!this.$mobileMenuFooter.length) return;

      const $buttons = this.$mobileMenuFooter.find("button, a");
      const $svgs = this.$mobileMenuFooter.find("svg");
      const $labels = this.$mobileMenuFooter.find(".ds-label");

      // Remove active from all items
      // Remove active from all items
      $buttons.each((index, button) => {
        const $button = $(button);
        $button.removeClass("active");

        // Hide active icon, show default icon
        $button.find("svg.ds-icon-active").addClass("tw-hidden");
        $button.find("svg.ds-icon-default").removeClass("tw-hidden");
      });
      
      $svgs
        .removeClass("tw-text-ds-primary")
        .addClass("tw-text-ds-icon-neutral");

      $labels.removeClass("tw-font-ds-strong tw-text-ds-primary");

      let $activeItem;

      // Set active based on target
      if (target === "/" || target === "") {
        $activeItem = this.$mobileMenuFooter.find('a[href="/"]');
      } else if (target === "categories") {
        $activeItem = this.$mobileMenuFooter.find(
          '[data-tid="mobile-menu-footer-categories"]'
        );
      } else if (target === "search") {
        $activeItem = this.$mobileMenuFooter.find("button").eq(1);
      } else if (target === "cart" || target.includes("/cart")) {
        $activeItem = this.$mobileMenuFooter.find('a[href*="cart"]');
      }

      // Add active class to selected item
      if ($activeItem && $activeItem.length) {
        $activeItem.addClass("active");

        // Hide default icon, show active icon
        $activeItem.find("svg.ds-icon-default").addClass("tw-hidden");
        $activeItem.find("svg.ds-icon-active").removeClass("tw-hidden");

        $activeItem
          .find(".ds-label")
          .addClass("tw-font-ds-strong tw-text-ds-primary");
      }
    }

    // Close modal
    closeModal() {
      if (this.$dialog.length) {
        this.$dialog.attr("data-state", "closed");
        this.$dialog.hide();
        $("body").css("overflow", ""); // Re-enable scrolling
      }
    }

    // Open modal
    openModal() {
      if (this.$dialog.length) {
        this.$dialog.attr("data-state", "open");
        this.$dialog.show();
        $("body").css("overflow", "hidden"); // Prevent scrolling
      }
    }

    // Check if modal is open
    isModalOpen() {
      return this.$dialog.length && this.$dialog.attr("data-state") === "open";
    }

    // Toggle nav item (open/close L1 submenu)
    toggleNavItem($item) {
      const $navLink = $item.find(".nav-link").first();
      const $toggleBtn = $item.find(".nav-arrow-toggle").first();
      const $subMenu = $item.find(".nav-l2").first();
      const isExpanded = $navLink.hasClass("nav-link--open");

      // Close all other nav items (optional - uncomment if you want only 1 item open)
      this.$navItems.not($item).each((index, otherItem) => {
        const $otherItem = $(otherItem);
        $otherItem.find(".nav-link").first().removeClass("nav-link--open");
        $otherItem
          .find(".nav-arrow-toggle")
          .first()
          .removeClass("arrow-toggle--open")
          .attr("aria-expanded", "false");
        $otherItem.find(".nav-l2").first().slideUp(300);
      });

      // Toggle current item
      if (isExpanded) {
        $navLink.removeClass("nav-link--open");
        $toggleBtn
          .removeClass("arrow-toggle--open")
          .attr("aria-expanded", "false");
        $subMenu.slideUp(300);
      } else {
        $navLink.addClass("nav-link--open");
        $toggleBtn.addClass("arrow-toggle--open").attr("aria-expanded", "true");
        $subMenu.slideDown(300);
      }
    }

    // Toggle L2 subcategory (open/close L3 submenu)
    toggleL2Category($category) {
      const $title = $category.find(".nav-l2__title");
      const $toggleBtn = $category.find(".nav-l2__arrow-toggle");
      const $subMenu = $category.find("div").first(); // L3 submenu container
      const isExpanded = $toggleBtn.hasClass("arrow-toggle--open");

      // Toggle current L2 category
      if (isExpanded) {
        $title.removeClass("font-weight-bold");
        $toggleBtn
          .removeClass("arrow-toggle--open")
          .attr("aria-expanded", "false");
        $subMenu.slideUp(300);
      } else {
        $title.addClass("font-weight-bold");
        $toggleBtn.addClass("arrow-toggle--open").attr("aria-expanded", "true");
        $subMenu.slideDown(300);
      }
    }

    // Toggle action menu
    toggleActionMenu() {
      if (this.$actionMenu.length) {
        this.$actionMenu.toggleClass("action-menu--expanded");
      }
    }
  }

  // Initialize when DOM is ready
  $(document).ready(function () {
    window.mobileNav = new MobileNavigation();
  });
})(jQuery);
